export default "__VITE_ASSET__0785a795__"